import { StatusBadge } from "@swot/base-components";

export function CmtsComplaintStatusBadge({ status, stage }: { readonly status?: unknown; readonly stage?: unknown }) {
  const label = String(status ?? stage ?? "Backend state");
  const normalized = label.toLowerCase();
  const tone = normalized.includes("closed") || normalized.includes("complete") || normalized.includes("pass") ? "success" : normalized.includes("blocked") || normalized.includes("fail") || normalized.includes("breach") ? "danger" : "info";
  return <StatusBadge tone={tone} label={label} />;
}
